import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "onClick", "tooltip", "usageTracker", "usageTrackerAppLocationKey", "loading"];
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useTracker } from '../../hooks/useTracker';
import { AIBaseLoadingIconButton } from './internal/AIBaseLoadingIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const AILoadingIconButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      onClick,
      tooltip,
      usageTracker,
      usageTrackerAppLocationKey,
      loading
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('aiButtonInteraction', {
          type: 'icon - trigger',
          featureId,
          featureCategoryId
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseLoadingIconButton, Object.assign({}, props, {
      "data-test-id": props['data-test-id'] || 'ai-icon-button',
      onClick: handleClick,
      loading: loading,
      children: children
    }))
  });
};
export default AILoadingIconButton;